import React  from 'react'
import DropDown from '../dropdown';
import { GetGuestTitles } from '../../../api/services/finance';

const GuestTitlesDropDown = ({...rest}) => {
    return <DropDown api={GetGuestTitles} textField="Name" valueField="Id"  {...rest}/>
}

export default GuestTitlesDropDown
